export default function ready(cb) {
  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', () => {
        cb();
      })
    : cb();
}
